module.exports = __webpack_public_path__ + "static/step3-5031d0b11409c8093482302c6b32c4f9.mp4";